import { Channels } from 'generated-graphql/types';
import { Fields } from 'common/form';

import {
  SourcingInviteCandidateSmsFormData,
  SourcingInviteCandidateEmailFormData
} from '../schema/sourcingSharedInviteMessageSchema';
import { SMS_MAX_CHARS_INVITATION } from 'modules/sourcing-shared/constants';

const OPENING_MESSAGE_SUB_LABEL_SMS = `▪ ${SMS_MAX_CHARS_INVITATION} character maximum.
    ▪ An opt-out message with "STOP" must be included.`;

const OPENING_MESSAGE_SUB_LABEL_EMAIL =
  'If you edit this, it will no longer be affected by changes to the opening message template.';

export const getSourcingSharedInvitationMessageFields = ({
  candidateFullName,
  customInvitationMessageDefaultValue,
  channelType
}: {
  candidateFullName: string;
  customInvitationMessageDefaultValue: string;
  channelType: Channels;
}):
  | Fields<SourcingInviteCandidateEmailFormData>
  | Fields<SourcingInviteCandidateSmsFormData> => {
  return {
    customTemplatedMessage: {
      type: 'textarea',
      label: `Edit ${candidateFullName.split(' ')[0]}'s invitation`,
      subLabel:
        channelType === Channels.Sms
          ? OPENING_MESSAGE_SUB_LABEL_SMS
          : OPENING_MESSAGE_SUB_LABEL_EMAIL,
      rows: 25,
      defaultValue: customInvitationMessageDefaultValue,
      maxCharacters:
        channelType === Channels.Sms ? SMS_MAX_CHARS_INVITATION : undefined
    }
  };
};
